export default __webpack_public_path__ + "static/media/compatible-shopify.6ffc90f7.svg";